// got from https://stackoverflow.com/a/1147768/5264262
var height = function(){
    var body = document.body,
    html = document.documentElement;
    
    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
}

export default height;


//////////////////
// WEBPACK FOOTER
// ./src/utils/document-height.js
// module id = 10
// module chunks = 0